// extracted by mini-css-extract-plugin
export var headerCell = "_43-1";
export var loadingSpinnerContainer = "_43-4";
export var rowWrapper = "_43-3";
export var standaloneTable = "_43-5";
export var table = "_43-0";
export var white = "_43-2";